export default __webpack_public_path__ + "static/media/handsandnote.3393f3d6.png";